import { IUser } from "../../types";
import { DetailsItem } from "./detail-item";

interface PersonalDetailsProps {
  userProfile: IUser;
}

const PersonalDetails = ({ userProfile }: PersonalDetailsProps) => {
  return (
    <div className="border shadow-sm p-6 rounded-lg">
      <p className="text-xl mb-2">Personal Details</p>
      <div className="flex flex-col space-y-2">
        <DetailsItem label="Email" value={userProfile?.email} disabled />
        <DetailsItem label="Phone Number" value={userProfile?.phone} disabled />
        <DetailsItem label="Gender" value={userProfile?.gender} disabled />
        {/* <DetailsItem
          label="User Status"
          value={userProfile?.userStatus || ""}
          disabled
        /> */}
        <DetailsItem label="Role" value={userProfile?.role || ""} disabled />
      </div>
    </div>
  );
};

export default PersonalDetails;
